import script from "./ImgBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImgBox.vue?vue&type=script&lang=ts&setup=true"

import "./ImgBox.vue?vue&type=style&index=0&id=36b9a664&lang=less&scoped=true"

import exportComponent from "/Users/chengyanbin/Codes/Daming/ksdm_offline/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b9a664"]])

export default __exports__